<template lang="pug">
  .home.dashboard.padding-container
    Flexible.margin-top-10
      .col.mg-top.mr.small
        Info(v-if="isPremium() == false")
          p {{ $t('interface.no_premium') }}
          router-link(to="/premium").no-dec
            Button(type="outline center small-width" :text="$t('interface.purchase')")
        Info(v-else)
          p {{ $t('interface.yes_premium') }}
        h3 Hello {{ user.name }}
        div(v-if="isPremium() == true")
          p Please see the list of documents available to download.
          br
          p Below this list are a range of new documents and services that may be of use, please contact PPHR if you would like to add these services to your business.
        div(v-else)
          p As your account is currently not premium, you have limited access to documents.
        SuggestionBox
        NoteBox
      .col.mg-top.ml.tab-content
        DocumentList
</template>

<script>
  import TabsComponent from '@/components/Tabs'
  import DocumentList from '@/components/documents/DocumentList'
  import Info from '@/components/notifications/Info'
  import NoteBox from '@/components/notes/NoteBox'
  import SuggestionBox from '@/components/notes/SuggestionBox'
  import Thumbnail from '@/components/documents/Thumbnail'
  import AuthService from '@/services/auth.js'

  export default {
    name: "dashboard",
    components: { 
      'Tabs': TabsComponent,
      DocumentList,
      Info,
      Thumbnail,
      SuggestionBox,
      NoteBox
    },
    data: function() {
      return {
        tabs: ['introduction','recruitment','probation_periods','absence','useful_forms','gdpr','payroll','leaving','covid-19_-_employer_support'],
        start_tab: 'introduction',
        premium: false
      }
    },
    mounted: function() {
      this.do_welcome();
      this.premium = this.checkPremium();
    },
    computed: {
      // we get the user state when they are logged in
      user: function() {
        const user = this.$store.state.user;
        console.log(user)
        return user;
      },
    },
    methods: {
      do_welcome: function() {
        if(this.$route.params.id == 'welcome') {
          this.$swal.fire({
            title: 'Welcome',
            text: 'Welcome to Compliance For You. Click "OK" To get started.',
            type: 'success'
          })
            .then((result) => {
              if (result.value) {
                this.$swal.fire(
                  'Getting Started',
                  'As a Free user, you will have access to some free versions of our documents.\nTo access all of our documents - please head into "Premium"',
                )
                this.$router.push({
                  path: '/dashboard',
                })
              }
            })
        }
      },
      locked_class: function() {
        if(this.$store.getters.user.premium == true)
          return '';
        return 'locked';
      },
      async checkPremium() {
        try {
          const response = await AuthService.is_premium();

          if(response) {
            const is_premium = (response.data === true ? true : false);
            this.$store.dispatch('setPremium', is_premium)
            this.premium = is_premium;
            return is_premium;
          } else {
            return false;
          }
          
        } catch(error) {
          console.log('could not check premium due to an error.')
          console.log(error);
        } 
      }
    }
  }
</script>

<style lang="scss">
  h1,h2,h3 {
    margin-bottom:12px;
  }
  .services-column {
    hr {
      border-radius:0px;
    }
  }
  .service-list-box {
    // background:#fefefe;
    z-index:10;
    min-height:550px;
    max-width:830px;
    position:relative;
    // margin-bottom:128px;

    .inner {
      position:absolute;
      // background:#fff;
      height:100%;
      width:100%;
    }

    .flexible.jleft {
      flex-wrap: wrap;
      width:100%;
    }
  }
  .dashboard {
    // min-height:900px;
    max-width:1460px;
    // padding-bottom:345px !important;
    @media screen and (max-width: 1480px) {
      width:89%;
    }
    .tab-content {
      margin-bottom:15px;
    }
  }
</style>